module.exports = [{
      plugin: require('/Users/hgr/ws/website-js/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/hgr/ws/website-js/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[],"offsetY":"50"},
    },{
      plugin: require('/Users/hgr/ws/website-js/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography.js"},
    },{
      plugin: require('/Users/hgr/ws/website-js/node_modules/gatsby-plugin-accessibilityjs/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/hgr/ws/website-js/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
